import React from "react";
import "./SuperDealMoveDetails.scss"
import { CardLayout } from "components/cardLayout";
import { CardItem } from "components/cardItem";
import { CardSubItem } from "components/cardSubItem";
import { apartment } from "assets/images"
import { bed1 } from "assets/images"
import { local } from "assets/images"
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { SuperDealsMoveDetailsCard } from "components/superDealsMoveDetailsCard";
import { Button } from "components/button";
import { PackageInfo } from "components/packageInfo";
import moment from "moment";
import { MoveListCard } from "components/moveListCard";
import { navigate } from "@reach/router";
import { RecentReviewsCard } from "components/recentReviewsCard";
import { createLeadQuery } from "core/services/LeadService"
import { client } from "App";
import { getEstFlowEstimateDetails } from "../../core/services/moveDetailsByCustomer"
import { Popup } from "components/Popup"
import { FormControl } from 'react-reactive-form';
import { StickyContainer, Sticky } from 'react-sticky';
import { getAmounts } from "core/services/amountService";
import Spinner from "components/spinner/spinner";

let lastScrollY = 0;
let ticking = false;
let renderCount = 0;

export interface SuperDealMoveDetailsProps {
    formControl?: FormControl;
    onClick?(): void;
    title?: any;
}

export interface SuperDealMoveDetailsState {
    Estimator: any;
    isDetails: boolean,
    totalAmt:any,
    loading: boolean;
    Customer?:any
}

class SuperDealMoveDetails extends React.Component<SuperDealMoveDetailsProps, SuperDealMoveDetailsState> {
    private _isMounted: boolean = false;
    constructor(props: SuperDealMoveDetailsProps) {
        super(props);
        this.state = {
            Estimator: [],
            isDetails: false,
            totalAmt:null,
            loading:true,
            Customer:[]
        };
    }

    getPrice() {
        localStorage.setItem("isAffirm", "0");
        if (this.props.onClick) {
            this.props.onClick()

        }
        this.addLead();
    }

    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        let response = await getEstFlowEstimateDetails(CID)

        console.log(response);
        this.setState({ Estimator: response[0] })
        console.log("EstimatorDetails:" + JSON.stringify(this.state.Estimator));
        localStorage.setItem("EstimatorDetails", JSON.stringify(this.state.Estimator))
    }

    addLead() {
        //localStorage.removeItem("leadDetails")
        this.createLead()
            .then(response => {
                localStorage.setItem("leadDetails", JSON.stringify(response.data.createLead[0]))
                console.log(response)
            });

    }


    async createLead() {
        console.clear();
        /* var LeadInput = {
                 firstName: this.formGroup.value.name + '',
                 lastName:"",
                 telephone: (this.formGroup.value.Telephone) ? this.formGroup.value.Telephone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "") : "",
                 email:"Didnotprovide@allmysons.com",
                 moveDate:movingDate,
                 moveSize:"1",
                 originZip:object.Zipcode,
                 src:"googlebapt1br",
                 destinationZip:"",
                 aPIReferenceID:"1",
                 canWeText:"true",
                 clientIPAddress:"",
                 moveType:object.MoveType,
                 promoCode:"",
                 unitNo:"",
                 address: "",
                 movingDateNotSure:notSure
               } 
             console.log("LeadInput:" + JSON.stringify(LeadInput)); */

        return client.query({
            query: createLeadQuery, variables: {
                leadInput: {
                    application: "estimate",
                    customerID: localStorage.getItem("CID")

                }
            }
        });
    }

    openMoveDetail(move: any) {
        //debugger;
        // navigate(`/moves/${move.moveID}`);
        // alert("click me")
    }



    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
        this.fetchAmountData();
        // window.addEventListener('scroll', this.handleScroll, true);
    }
    async fetchAmountData() {
        // debugger;
        var cid = (localStorage.getItem("CID") || "");
        localStorage.setItem("isAffirm", "0");
        //var cid="6980914";
        let response = await getAmounts(cid);

        localStorage.setItem("amounts", JSON.stringify(response.data.getEstFlowTotalAmountsAndDetails))
        console.log(response.data.getEstFlowTotalAmountsAndDetails)
        let currentAmounts = JSON.parse(localStorage.getItem("amounts") || '{}')
        let depositAmt = currentAmounts[4].amount;
        let total= currentAmounts.find((item: any) => item.type === "Total")

        this.setState({totalAmt:total?.amount, loading: false,Customer: localStorage.getItem("customerDetails")});
        if (this.props.formControl) {
            // debugger;
            this.props.formControl.setValue(true);
        }
        if (!this.props.formControl) {
            //  debugger;
        }
    }

    nav = React.createRef();

    handleScroll = () => {
        lastScrollY = window.scrollY;
        console.log(lastScrollY)
        if (lastScrollY === 0) {
            this.setState({ isDetails: false })
        }
        else {
            this.setState({ isDetails: true })
        }
        console.log(this.state.isDetails)
        if (!ticking) {
            window.requestAnimationFrame(() => {
                //    nav.current.style.top = `${lastScrollY}px`;
                ticking = false;
            });

            ticking = true;
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
        // window.removeEventListener('scroll', this.handleScroll);
    }
    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var address = object.address + ", #" + object.Unit
        var weekday = moment(object.MoveDate).format("d")
        var isSuper = parseInt(weekday) <= 3 ? 1 : 0;

        return (
            this.state.loading ? <Spinner /> :<div className="superdeal-container">
                {/* <div className="movedetail-title"> */}
                {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                {/* <h1>Your Move Includes</h1> */}
                {/* </div> */}

                {/* {
                    !this.state.isDetails ? <SuperDealsMoveDetailsCard />
                        : <></>
                } */}


                {/* <PackageInfo/> */}
                {/* <div> */}
                <StickyContainer className="container relative">
                    <div
                        className="gap tall"
                        style={{ background: "#f3f3f3" }}
                    >
                        <div className="gap short" />
                        <div className="movedetail-title">
                            {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                            <h1>Your Move Includes</h1>
                        </div>

                        {
                            !this.state.isDetails ? <SuperDealsMoveDetailsCard total={this.state.totalAmt} />
                                : <></>
                        }
                        <Sticky relative={true}>
                            {({ style }) => (
                                //@ts-ignore
                                // <h1 style={style} renderCount={renderCount++}>Sticky heading</h1>
                                <div className="getprice-btn" style={style} renderCount={renderCount++}>
                                    <Button
                                        text={"CONTINUE"}
                                        onClick={() => this.getPrice()}
                                    />
                                </div>
                            )}
                        </Sticky>
                        <div className="gap short" />
                        {/* <h2>scrolling container</h2> */}

                        <RecentReviewsCard
                            title="Recent Reviews Near You"
                            onClick={(item: any) => this.openMoveDetail(item)}
                            formControl={this.props.formControl}
                        />

                    </div>
                </StickyContainer>
                {/* </div> */}
                {/* <div className="getprice-btn" >
                    <Button
                        text={"Continue"}
                        onClick={() => this.getPrice()}
                    />
                </div> */}

                {/* <RecentReviewsCard
                    title="Recent Reviews Near You"
                    onClick={(item: any) => this.openMoveDetail(item)}
                    formControl={this.props.formControl}
                /> */}

                {/* <MoveListCard
                    title="Recent Reviews Near You"
                    // paymentStatuses={NO_PAYMENT_STATUS}
                    // moveStatuses={NO_MOVE_STATUS}
                    // list={this.getMoves(NO_PAYMENT_STATUS, NO_MOVE_STATUS)}
                    onClick={(item: any) => this.openMoveDetail(item)}
                    cancelAmount={true}
                    cancelTotalAmount={true}
                /> */}

            </div>
        );
    }
}

export default SuperDealMoveDetails;